import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6605343f&scoped=true"
import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=6605343f&prod&scoped=true&lang=css"
import style1 from "./App.vue?vue&type=style&index=1&id=6605343f&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6605343f",
  null
  
)

export default component.exports